// extracted by mini-css-extract-plugin
export default {"button":"Hotspot_button__ovEtO","active":"Hotspot_active__woTh1"};